function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import Box from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import MaterialCircularProgress from "../../../../__snowpack__/pkg/@mui/material/CircularProgress.js";
import MaterialLinearProgress from "../../../../__snowpack__/pkg/@mui/material/LinearProgress.js";
import Typography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useMemo} from "react";
import {ProgressContainer} from "./progress.styles.js";
function Progress({
  circular,
  withLabel,
  variant,
  color,
  value,
  valueBuffer,
  size,
  disableShrink,
  thickness
}) {
  const props = useMemo(() => ({
    variant,
    color,
    value,
    valueBuffer,
    size,
    disableShrink,
    thickness
  }), [color, disableShrink, size, thickness, value, valueBuffer, variant]);
  const Linear = useMemo(() => /* @__PURE__ */ React.createElement(MaterialLinearProgress, {
    variant,
    color,
    value,
    valueBuffer
  }), [color, value, valueBuffer, variant]);
  const Circular = useMemo(() => /* @__PURE__ */ React.createElement(MaterialCircularProgress, {
    variant,
    color,
    value,
    size,
    disableShrink,
    thickness
  }), [color, disableShrink, size, thickness, value, variant]);
  const Prg = useMemo(() => {
    if (withLabel) {
      if (circular) {
        return /* @__PURE__ */ React.createElement(Box, {
          position: "relative",
          display: "inline-flex"
        }, /* @__PURE__ */ React.createElement(MaterialCircularProgress, _extends({}, props, {
          variant: "determinate"
        })), /* @__PURE__ */ React.createElement(Box, {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }, /* @__PURE__ */ React.createElement(Typography, {
          variant: "caption",
          component: "div",
          color: "textSecondary"
        }, `${Math.round(value || 0)}%`)));
      } else {
        return /* @__PURE__ */ React.createElement(Box, {
          display: "flex",
          alignItems: "center"
        }, /* @__PURE__ */ React.createElement(Box, {
          width: "100%",
          mr: 1
        }, /* @__PURE__ */ React.createElement(MaterialLinearProgress, _extends({}, props, {
          variant: "determinate"
        }))), /* @__PURE__ */ React.createElement(Box, {
          minWidth: 35
        }, /* @__PURE__ */ React.createElement(Typography, {
          variant: "body2",
          color: "textSecondary"
        }, `${Math.round(value || 0)}%`)));
      }
    } else {
      if (circular) {
        return Circular;
      } else {
        return Linear;
      }
    }
  }, [Circular, Linear, circular, props, value, withLabel]);
  return /* @__PURE__ */ React.createElement(ProgressContainer, null, Prg);
}
export default /* @__PURE__ */ React.memo(Progress);
